import { takeLatest, put } from 'redux-saga/effects';
import { TaskAPI } from 'api/tasks';
import { FetchStatus } from 'data/core';
import { saveTasks, createTaskSuccess } from 'data/tasks/slice';
import { addTaskToSpaceTab, updateSpaceTabTaskList } from '..';
import { createTaskFromSpaceTabSagaAction } from '../actions';
function* createTaskFromSpaceTabSaga({ payload }) {
    const { projectId, spaceTabId, task } = payload;
    const { taskId, ...rest } = task;
    const taskData = {
        ...task,
        project: {
            projectId
        }
    };
    yield put(saveTasks({
        data: [
            taskData
        ],
        fetchStatus: FetchStatus.Partial
    }));
    if (taskId) {
        yield put(addTaskToSpaceTab({
            spaceTabId,
            taskId
        }));
        const response = yield TaskAPI.createTask(projectId, rest);
        yield put(createTaskSuccess({
            task: response,
            projectId,
            tempTaskId: taskId
        }));
        yield put(updateSpaceTabTaskList({
            spaceTabId,
            taskId: response.taskId,
            tempTaskId: taskId
        }));
    }
}
export function* watchCreateTaskFromSpaceTabSaga() {
    yield takeLatest(createTaskFromSpaceTabSagaAction.type, createTaskFromSpaceTabSaga);
}
